import { RouletteColor } from '@/models/roulette/color';

export const fortuneDoubleColors = new Map<RouletteColor, string>([
  [RouletteColor.Red, '#ED9F00'],
  [RouletteColor.White, '#66B2FF'],
  [RouletteColor.Black, '#EF28A9'],
]);

export const fortuneBackgroundColors = new Map<RouletteColor, string>([
  [RouletteColor.Red, '#ED9F00'],
  [RouletteColor.White, '#66B2FF'],
  [RouletteColor.Black, '#EF28A9'],
]);
